module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_8019.be884b09.png";